import { createI18n } from 'vue-i18n'
import {languages} from '../../../storage/app/translations';

const messages = Object.assign(languages)

const i18n = createI18n({
  legacy: false,
  locale: document.querySelector('meta[name="lang"]').getAttribute('content'),
  globalInjection: true,
  fallbackLocale: 'en',
  messages
})

if (!window.i18n) {
  window.i18n = i18n
}

export default i18n;
